export default __webpack_public_path__ + "static/logo-2a316454af82b6dbbda18eed03d28171.webp";